var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.val)+" "),(_vm.value)?_c('span',{staticClass:"ma-1",staticStyle:{"cursor":"pointer"},attrs:{"title":"Позвонить"},on:{"click":function($event){return _vm.$root.$emit('global-call', _vm.value)}}},[_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("fas fa-phone")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }